import { createAsyncThunk } from '@reduxjs/toolkit';
import personExperienceService from './PersonExperience.service';
import { PersonExperienceParams } from './PersonExperience.type';

export const getPersonExperienceListThunk = createAsyncThunk(
  'personExperience/getPersonExperienceListThunk',
  async (params: PersonExperienceParams, thunkAPI) => {
    const response = await personExperienceService.getList(params);
    return response.data;
  },
);
